<template>
  <div class="coupon-detail-page">
    <div class="content-box">
      <div class="box1">
        <div class="flex-row col-center row-between" style="padding: 15px 20px">
          <div class="flex-col row-between" style="height: 70px">
            <div>
              <span>0</span>
              <span>张票</span>
            </div>
            <div>
              购买非电影商品可用0.00元
            </div>
            <div>
              85622223
            </div>
          </div>
          <div>
            <img alt="" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" style="width: 65px;height: 65px">
          </div>
          <div class="flex-col row-between" style="height: 70px">
            <div>A类次票券</div>
            <div>2020-11-13至2021-11-15</div>
          </div>
        </div>
      </div>
      <div class="box2 flex-row row-center col-center">
        <div class="line"></div>
        <div class="title-box">优选 . 全场通用</div>
        <div class="line"></div>
      </div>
      <div class="box3 mt22">
        <div class="flex-row">
          <div>
            <div style="width: 211px;height: 96px;background: #A1C4FF;border-radius: 5px;"></div>
            <div class="flex-row" style="margin-top: 5px">
              <div style="width: 104px;height: 101px;background: #C0A1FF;border-radius: 5px;">

              </div>
              <div style="width: 102px;height: 101px;background: #FFB7A1;border-radius: 5px;margin-left: 5px">

              </div>
            </div>
          </div>
          <div style="width: 138px;height: 202px;background: #FFCCCC;border-radius: 5px;margin-left: 5px">

          </div>
        </div>
      </div>
      <div class="box4 mt22">
        <van-cell is-link title="使用范围"/>
        <van-cell is-link title="使用规则"/>
        <van-cell is-link title="消费明细"/>
        <van-cell is-link title="使用区域"/>
        <van-cell is-link title="券号密码"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style lang="scss" scoped>
@import "index";
</style>
